import { render } from "./ButtonClose.vue?vue&type=template&id=121b0170&scoped=true"
const script = {}

import "./ButtonClose.vue?vue&type=style&index=0&id=121b0170&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121b0170"]])

export default __exports__